if (!customElements.get('wls-5050')) {
    class WLS5050 extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                body: 'js-wls-5050-body',
                content: 'js-wls-5050-content', 
                inner: 'js-wls-5050-inner',
                title: 'js-wls-5050-title',
                button: 'js-wls-5050-button',
            };
            this.elements = {
                body: this.querySelector(`.${this.classes.body}`),
                content: this.querySelector(`.${this.classes.content}`),
                inner: this.querySelector(`.${this.classes.inner}`),
                title: this.querySelector(`.${this.classes.title}`),
                button: this.querySelector(`.${this.classes.button}`),
            };

            this.mediaQuery = window.matchMedia('(min-width: 768px)');
            this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);
            this.handleResize = this.handleResize.bind(this);
            this.updateInnerHeight = this.updateInnerHeight.bind(this);
        }

        /**
         * @description Add event listeners and start observing the elements
         */
        connectedCallback() {
            this.mediaQuery.addEventListener('change', this.handleMediaQueryChange);
            window.addEventListener('resize', this.handleResize);
            
            // Initial layout setup
            this.handleMediaQueryChange(this.mediaQuery);
            
            // Initial height setup after a small delay to ensure content is rendered
            setTimeout(() => {
                this.updateInnerHeight();
            }, 100);
        }

        /**
         * @description Disconnect the observer and remove the event listeners
         */
        disconnectedCallback() {
            this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange);
            window.removeEventListener('resize', this.handleResize);
        }

        /**
         * @description Handle window resize events
         */
        handleResize() {
            this.handleMediaQueryChange(this.mediaQuery);
            this.updateInnerHeight();
        }

        /**
         * @description Update inner element min-height based on content height
         */
        updateInnerHeight() {
            if (!this.elements.inner || !this.elements.content) return;
            
            // Reset inner height to auto first
            this.elements.inner.style.minHeight = 'auto';
            
            // Get content height after elements are moved
            const contentHeight = this.elements.content.offsetHeight;
            
            // Set inner min-height to match content
            this.elements.inner.style.minHeight = `${contentHeight}px`;
        }

        /**
         * @description Handle media query changes
         * @param {MediaQueryList} e Media query event
         */
        handleMediaQueryChange(e) {
            if (e.matches) {
                // Desktop (>= 768px) - Move title and button to content div
                this.moveToDesktopLayout();
            } else {
                // Mobile (< 768px) - Move title and button to body div
                this.moveToMobileLayout();
            }
            
            // Update height after layout changes
            this.updateInnerHeight();
        }

        /**
         * @description Move elements to desktop layout (title and button in content div)
         */
        moveToDesktopLayout() {
            if (!this.elements.content) return;

            // Move title to content div as first child
            if (this.elements.title && this.elements.title.parentNode !== this.elements.content) {
                this.elements.content.insertBefore(this.elements.title, this.elements.content.firstChild);
            }

            // Move button to content div as last child
            if (this.elements.button && this.elements.button.parentNode !== this.elements.content) {
                this.elements.content.appendChild(this.elements.button);
            }
        }

        /**
         * @description Move elements to mobile layout (title and button in body div)
         */
        moveToMobileLayout() {
            if (!this.elements.body) return;

            // Move title to body div as first child (before content)
            if (this.elements.title && this.elements.title.parentNode !== this.elements.body) {
                this.elements.body.insertBefore(this.elements.title, this.elements.body.firstChild);
            }

            // Move button to body div as last child
            if (this.elements.button && this.elements.button.parentNode !== this.elements.body) {
                this.elements.body.appendChild(this.elements.button);
            }
        }
    }

    customElements.define('wls-5050', WLS5050);
}
